// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"01ef34b6","306":"982fe7bc","545":"4a8e0eee","829":"0fe674ea"}[chunkId] + ".chunk.js";
};